import {
  size_default
} from "./chunk.SI24X5IH.js";
import {
  LocalizeController
} from "./chunk.ZPJRWEFM.js";
import {
  variants_default
} from "./chunk.7OG3CMFN.js";
import {
  appearance_default
} from "./chunk.GO6CI477.js";
import {
  WebAwesomeElement,
  n,
  t
} from "./chunk.LVUMIIKQ.js";
import {
  ke
} from "./chunk.S3625EU6.js";
import {
  __decorateClass
} from "./chunk.SZE6ONST.js";

// src/events/remove.ts
var WaRemoveEvent = class extends Event {
  constructor() {
    super("wa-remove", { bubbles: true, cancelable: false, composed: true });
  }
};

// src/components/tag/tag.css
var tag_default = ":host {\n  --size-s: var(--wa-font-size-xs);\n  --size-m: var(--wa-font-size-s);\n  --size-l: var(--wa-font-size-m);\n\n  display: inline-flex;\n  border-radius: var(--wa-border-radius-m);\n  align-items: center;\n  background-color: var(--background-color, var(--wa-color-fill-quiet));\n  border-color: var(--border-color, transparent);\n  border-style: var(--wa-border-style);\n  border-width: var(--wa-border-width-s);\n  color: var(--text-color, var(--wa-color-on-normal));\n  line-height: 1;\n  white-space: nowrap;\n  user-select: none;\n  -webkit-user-select: none;\n  height: calc(var(--wa-form-control-height) * 0.8);\n  line-height: calc(var(--wa-form-control-height) - var(--wa-form-control-border-width) * 2);\n  padding: 0 var(--wa-space-smaller);\n}\n\n[part='remove-button'] {\n  color: inherit;\n  padding: 0;\n  margin-inline-start: 0.75em;\n}\n\n[part='remove-button']::part(base) {\n  padding: 0;\n}\n\n:host(:hover) > wa-icon-button {\n  color: color-mix(in oklab, var(--text-color), var(--wa-color-mix-hover));\n}\n\n:host(:active) > wa-icon-button {\n  color: color-mix(in oklab, var(--text-color), var(--wa-color-mix-active));\n}\n\n/*\n * Pill modifier\n */\n\n:host([pill]) {\n  border-radius: var(--wa-border-radius-pill);\n}\n";

// src/components/tag/tag.ts
var WaTag = class extends WebAwesomeElement {
  constructor() {
    super(...arguments);
    this.localize = new LocalizeController(this);
    this.variant = "inherit";
    this.appearance = "outlined filled";
    this.size = "inherit";
    this.pill = false;
    this.removable = false;
  }
  handleRemoveClick() {
    this.dispatchEvent(new WaRemoveEvent());
  }
  render() {
    return ke`
      <slot part="content" class="content"></slot>

      ${this.removable ? ke`
            <wa-icon-button
              part="remove-button"
              exportparts="base:remove-button__base"
              name="xmark"
              library="system"
              variant="solid"
              label=${this.localize.term("remove")}
              class="remove"
              @click=${this.handleRemoveClick}
              tabindex="-1"
            ></wa-icon-button>
          ` : ""}
    `;
  }
};
WaTag.shadowStyle = [size_default, variants_default, appearance_default, tag_default];
__decorateClass([
  n({ reflect: true, initial: "neutral" })
], WaTag.prototype, "variant", 2);
__decorateClass([
  n({ reflect: true })
], WaTag.prototype, "appearance", 2);
__decorateClass([
  n({ reflect: true, initial: "medium" })
], WaTag.prototype, "size", 2);
__decorateClass([
  n({ type: Boolean, reflect: true })
], WaTag.prototype, "pill", 2);
__decorateClass([
  n({ type: Boolean })
], WaTag.prototype, "removable", 2);
WaTag = __decorateClass([
  t("wa-tag")
], WaTag);

export {
  WaTag
};
